import {IWorkersRepository} from "@/repository/workers/WorkersRepository.types";
import Api from "@/repository/api";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";
import {
    IWorkers,
    IWorkersListItem,
    WorkersListItemResponseType,
    WorkersResponseType
} from "@/entity/workers/workers.types";

import Workers from "@/entity/workers/workers";
import WorkerDetail from "@/entity/workerDetail/workerDetail";
import {WorkerAddRequestType} from "@/form/workerAdd/workerAdd.types";
import {StaffUpdateRequestType} from "@/form/staff/StaffUpdate.types";
import {ResponseDataType} from "@/form/form.types";

export default class WorkersRepository implements IWorkersRepository {

    async fetchStaffSchedule(data?: PaginationRequestType): Promise<any> {

    }

    async fetchAll(data?: PaginationRequestType): Promise<IWorkers> {
        const response = await Api.get(`/staff/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const responseData = response.data as WorkersResponseType;
        return new Workers(responseData);
    }
    async fetchData(data: PaginationRequestType): Promise<IWorkersListItem> {
        const response = await Api.get(`/staff/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const responseData = response.data as IWorkersListItem;
        return new WorkerDetail(responseData);
    }
    async create(data: WorkerAddRequestType): Promise<ResponseDataType> {
        const res = await Api.post('/staff/create', data);
        return res.data;
    }
    async update(data: StaffUpdateRequestType): Promise<ResponseDataType> {
        const res = await Api.post('/staff/update', data);
        return res.data;
    }
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const res = await Api.post('/staff/delete', data);
        return res.data;
    }
}
